import { isDefaultOption } from '@/helpers/other';
import { AsyncSelect } from '@/ui/select/async/async-select';
import type { OptionType } from '@/ui/select/async/use-select-type';
import { sharedProps } from '@/ui/select/select-shared';
import type { IOption } from '@/types';
import { SmallText } from '@/ui/typography/action-panel';
import { styled } from 'goober';

interface Props {
  id?: string;
  label?: string;
  options: IOption[];
  defaultValue?: IOption[];
  onChange: (options: IOption) => void;
  isMulti?: boolean;
  placeholder?: string;
}

export const FormSelectWithPredefinedOptions = ({
  id,
  options,
  label,
  defaultValue,
  onChange,
  isMulti,
  placeholder,
}: Props) => {
  const setOptions = (search: string) => {
    return new Promise<OptionType[]>(resolve => {
      if (search) {
        resolve(
          options.filter(option =>
            option.label.toLowerCase().includes(search.toLowerCase()),
          ),
        );
      }
      resolve(options);
    });
  };

  return (
    <AsyncSelect
      id={id}
      dataTestId={id}
      label={label}
      defaultValue={defaultValue}
      setOptions={setOptions}
      isSearchable
      isMulti={isMulti}
      placeholder={<Placeholder>{placeholder}</Placeholder>}
      onChange={option => {
        if (!isDefaultOption(option)) return;

        onChange(option);
      }}
      {...sharedProps}
    />
  );
};

const Placeholder = styled(SmallText)`
  color: ${({ theme }) => theme.colors.gray.c8};
`;
